import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getInitialFiltersValue } from "../api/api";

export const setInitialValue = createAsyncThunk(
	'filter/setInitialValue',
	async () => {
		const response = await getInitialFiltersValue();
		return response;
	}
)

const initialState = {
	type: '',
	buildings: [],
	area: {
		min: 0,
		max: 0,
		minDefault: 0,
		maxDefault: 0,
	},
	price: {
		min: 0,
		max: 0,
		minDefault: 0,
		maxDefault: 0,
	},
	pool: false,
	yard: false,
	buildingOptions: null,
	typeOptions: null,
	sort: 'area_asc',
}

const changeValue = (state, action, field) => {
	state[field] = action.payload;
}

const changeRangeValue = (state, action, field) => {
	state[field].min = action.payload.min;
	state[field].max = action.payload.max;
}

export const filterSlice = createSlice({
	name: 'filter',
	initialState,
	reducers: {
		changeType: (state, action) => changeValue(state, action, 'type'),
		changeBuildings: (state, action) => changeValue(state, action, 'buildings'),
		changeArea: (state, action) => changeRangeValue(state, action, 'area'),
		changePrice: (state, action) => changeRangeValue(state, action, 'price'),
		changePool: (state, action) => changeValue(state, action, 'pool'),
		changeYard: (state, action) => changeValue(state, action, 'yard'),
		changeSort: (state, action) => changeValue(state, action, 'sort'),
		resetFilters: (state) => {
			state.type = '';
			state.buildings = [];
			state.area.min = state.area.minDefault;
			state.area.max = state.area.maxDefault;
			state.price.min = state.price.minDefault;
			state.price.max = state.area.maxDefault;
			state.pool = false;
			state.yard = false;
		}
	},
	extraReducers: {
		[setInitialValue.fulfilled]: (state, action) => {
			const buildings = [];
			const types = [];
			const isEnglish = document.body.classList.contains('en');
			const buildName = isEnglish ? 'Building' : 'Корпус';

			types.push({value: '', label: isEnglish ? 'All type' : 'Все типы'});
			for (let key in action.payload.select.section)
			{
				buildings.push({value: key, label: `${buildName} ${action.payload.select.section[key]}`});
			}

			for (let key in action.payload.select.type)
			{
				types.push({value: key, label: action.payload.select.type[key]});
			}

			state.buildingOptions = buildings;
			state.typeOptions = types;
			state.area.min = action.payload.range.area.min;
			state.area.minDefault = action.payload.range.area.min;
			state.area.max = action.payload.range.area.max;
			state.area.maxDefault = action.payload.range.area.max;
			state.price.min = action.payload.range.price.min;
			state.price.minDefault = action.payload.range.price.min;
			state.price.max = action.payload.range.price.max;
			state.price.maxDefault = action.payload.range.price.max;
		}
	},
});

export const { changeType, changeBuildings, changeArea, changePrice, changePool, changeYard, resetFilters, changeSort } = filterSlice.actions;

export default filterSlice.reducer;
